import { Box, FormControl, Image, Input, Stack, Text } from '@chakra-ui/react';
import React from 'react';
import { Img } from '../../../content/Content';
import BroadCastInfo from './BroadCastInfo';

const LiveChat = () => {
    return (
        <div>
            <Stack w="100%" pb="40px"  borderRadius="26px" bg={"rgba(255, 255, 255, 1)"}  mx="30px" mt="50px" mb="50px" className='desktop-version'>
            <BroadCastInfo/>
            </Stack>
            <Stack w="100%" pb="40px"  borderRadius="26px" bg={"rgba(255, 255, 255, 1)"}  mx="" mt="50px" mb="50px" className='mobile-version'>
            <BroadCastInfo/>
            </Stack>
            <Stack w="100%" pb="40px"  borderRadius="26px" bg={"rgba(255, 255, 255, 1)"}  mx="30px" mt="50px" mb="50px" className='desktop-version'>
                
            {/* Top Bar */}
            <Stack justifyContent={'flex-start'} alignItems={'center'} flexDir='row' w="100%" p={'15px 25px'} mt="40px" flexWrap='wrap' flexDirection={'column'}>
                <Image  src={Img.chat} width='13px'h="25px" /> 
                <Text                     
                fontFamily="ProximaNova"
                    fontSize="20px"
                    fontWeight="800"
                    color="rgba(41, 45, 50, 1)"
                    fontF=''
                    >Live Chat</Text>
              <Box borderBottom='1px solid rgba(236, 236, 236, 1)' w="100%" py='10px'></Box>       
            </Stack>
            {/*  Chat Box */}
            <Stack alignItems='center' justifyContent='flex-start' w="100%">
                {/* Left Chat */}
                <Box w="60%" display='flex' flexDir='column' justifyContent='center'>
                    {/* Chat */}
                    <Text  
                    textAlign='left'                   
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(151, 147, 147, 1)"
                    fontFamily='ProximaNova'
                    >
                        Trailor
                    </Text>

                    <Text  
                    bg="rgba(235, 235, 235, 1)"
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginTop='15px'
                    >
                       Hi! your last shot was realy good!
                    </Text>
                   <Image src={Img.chatAvatar} alt="chat" w="40px" h="40px" position='relative' top='' style={{top:'8px', left:'-31px'}} />
                </Box>
                {/* Right Chat */}
                <Box w="60%" display='flex' flexDir='column' justifyContent='center' marginStart="auto" paddingRight="25px">
                    {/* Chat */}
                    <Text  
                    textAlign='left'                   
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(151, 147, 147, 1)"
                    fontFamily='ProximaNova'
                    >
                        Autor
                    </Text>

                    <Text  
                    bg="rgba(235, 235, 235, 1)"
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginTop='15px'
                    >
                       Hi! your last shot was realy good!
                    </Text>
                </Box>
                {/* Left Chat */}
                <Box w="60%" display='flex' flexDir='column' justifyContent='center'>
                    {/* Chat */}
                    <Text  
                    textAlign='left'                   
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(151, 147, 147, 1)"
                    fontFamily='ProximaNova'
                    >
                        Trailor
                    </Text>

                    <Text  
                    bg="rgba(235, 235, 235, 1)"
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginTop='15px'
                    >
                       Hi! your last shot was realy good!
                    </Text>
                   <Image src={Img.chatAvatar} alt="chatAvatar" w="40px" h="40px" position='relative' top='14px' left="-31px" />
                </Box>
                {/* Right Chat */}
                <Box w="60%" display='flex' flexDir='column' justifyContent='center' marginStart="auto" paddingRight="25px">
                    {/* Chat */}
                    <Text  
                    textAlign='left'                   
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(151, 147, 147, 1)"
                    fontFamily='ProximaNova'
                    >
                        Autor
                    </Text>

                    <Text  
                    bg="rgba(235, 235, 235, 1)"
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginTop='15px'
                    >
                       Hi! your last shot was realy good!
                    </Text>
                </Box>
                                {/* Left Chat */}
                <Box w="60%" display='flex' flexDir='row' justifyContent='flex-start' alignItems='center'>
                    {/* Chat */}
                    <Image src={Img.typing} alt="chatAvatar" w="40px" h="40px" position='relative' left="-31px"  />
                    <Text  
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginLeft={'0'}
                    >
                       Trailor is Typing...
                    </Text>
                   
                </Box>
                <Box w="80%" mx="auto" my="15px">
                    <FormControl w="100%">
                        <Input
                        placeholder='Write Your massage'
                        border={'1px solid rgba(149, 151, 171, 1)'}
                        padding='18px 25px'
                        borderRadius='15px'
                        color=" rgba(149, 151, 171, 1)"
                        fontSize="14px"
                        fontFamily='ProximaNova'
                        _placeholder={{
                            color:" rgba(149, 151, 171, 1)",
                            fontSize:"14px",
                            fontFamily:'ProximaNova',
                        }}
                        w="100%"
                        />
                    </FormControl>
                </Box>
            </Stack>
            </Stack>

            <Stack w="100%" pb=""  borderRadius="26px" bg={"rgba(255, 255, 255, 1)"}  mx="" mt="50px" mb="50px" className='mobile-version'>
            {/* Top Bar */}
            <Stack justifyContent={'flex-start'} alignItems={'center'} flexDir='row' w="100%" p={'15px 25px'} mt="40px" flexWrap='wrap' flexDirection={'column'}>
                <Image  src={Img.chat} width='13px'h="25px" /> 
                <Text                     
                fontFamily="ProximaNova"
                    fontSize="20px"
                    fontWeight="800"
                    color="rgba(41, 45, 50, 1)"
                    fontF=''
                    >Live Chat</Text>
              <Box borderBottom='1px solid rgba(236, 236, 236, 1)' w="100%" py='10px'></Box>       
            </Stack>
            {/*  Chat Box */}
            <Stack alignItems='center' justifyContent='flex-start' w="100%">
                {/* Left Chat */}
                <Box w="60%" display='flex' flexDir='column' justifyContent='center'>
                    {/* Chat */}
                    <Text  
                    textAlign='left'                   
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(151, 147, 147, 1)"
                    fontFamily='ProximaNova'
                    >
                        Trailor
                    </Text>

                    <Text  
                    bg="rgba(235, 235, 235, 1)"
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginTop='15px'
                    >
                       Hi! your last shot was realy good!
                    </Text>
                   <Image src={Img.chatAvatar} alt="chat" w="40px" h="40px" position='relative' top='' style={{top:'8px', left:'-31px'}} />
                </Box>
                {/* Right Chat */}
                <Box w="60%" display='flex' flexDir='column' justifyContent='center' marginStart="auto" paddingRight="25px">
                    {/* Chat */}
                    <Text  
                    textAlign='left'                   
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(151, 147, 147, 1)"
                    fontFamily='ProximaNova'
                    >
                        Autor
                    </Text>

                    <Text  
                    bg="rgba(235, 235, 235, 1)"
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginTop='15px'
                    >
                       Hi! your last shot was realy good!
                    </Text>
                </Box>
                {/* Left Chat */}
                <Box w="60%" display='flex' flexDir='column' justifyContent='center'>
                    {/* Chat */}
                    <Text  
                    textAlign='left'                   
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(151, 147, 147, 1)"
                    fontFamily='ProximaNova'
                    >
                        Trailor
                    </Text>

                    <Text  
                    bg="rgba(235, 235, 235, 1)"
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginTop='15px'
                    >
                       Hi! your last shot was realy good!
                    </Text>
                   <Image src={Img.chatAvatar} alt="chatAvatar" w="40px" h="40px" position='relative' top='14px' left="-31px" />
                </Box>
                {/* Right Chat */}
                <Box w="60%" display='flex' flexDir='column' justifyContent='center' marginStart="auto" paddingRight="25px">
                    {/* Chat */}
                    <Text  
                    textAlign='left'                   
                    fontSize="14px"
                    fontWeight="400"
                    color="rgba(151, 147, 147, 1)"
                    fontFamily='ProximaNova'
                    >
                        Autor
                    </Text>

                    <Text  
                    bg="rgba(235, 235, 235, 1)"
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginTop='15px'
                    >
                       Hi! your last shot was realy good!
                    </Text>
                </Box>
                                {/* Left Chat */}
                <Box w="60%" display='flex' flexDir='row' justifyContent='flex-start' alignItems='center'>
                    {/* Chat */}
                    <Image src={Img.typing} alt="chatAvatar" w="40px" h="40px" position='relative' left="-31px"  />
                    <Text  
                    textAlign='center'                   
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(41, 41, 41, 1)"
                    fontFamily='ProximaNova'
                    display='flex'
                    alignItems='center'
                    justifyContent='center'
                    h="42px"
                    borderRadius='8px'
                    marginLeft={'0'}
                    >
                       Trailor is Typing...
                    </Text>
                   
                </Box>
                <Box w="80%" mx="auto" my="15px">
                    <FormControl w="100%">
                        <Input
                        placeholder='Write Your massage'
                        border={'1px solid rgba(149, 151, 171, 1)'}
                        padding='18px 25px'
                        borderRadius='15px'
                        color=" rgba(149, 151, 171, 1)"
                        fontSize="14px"
                        fontFamily='ProximaNova'
                        _placeholder={{
                            color:" rgba(149, 151, 171, 1)",
                            fontSize:"14px",
                            fontFamily:'ProximaNova',
                        }}
                        w="100%"
                        />
                    </FormControl>
                </Box>
            </Stack>
            </Stack>
        </div>
    );
};

export default LiveChat;